import { useEffect, useState } from "react";
import { Alert, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import http from "../../utils/http";

type Props = {
  studyId: string;
};

const SurveyInviteTemplateBanner = ({ studyId }: Props) => {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await http.get(
          `/admin/study/${studyId}/email-event-templates/all`
        );
        const rows = res?.data?.data || res?.data || [];
        const list = Array.isArray(rows) ? rows : [];
        const mapping = list.find(
          (row: any) => row?.eventName === "survey.invite"
        );
        const configured =
          !!mapping?.isEnabled &&
          !!(mapping?.templateId || mapping?.template?.providerTemplateId);
        if (!cancelled) {
          setShowWarning(!configured);
        }
      } catch {
        if (!cancelled) {
          setShowWarning(true);
        }
      }
    };
    if (studyId) {
      load();
    }
    return () => {
      cancelled = true;
    };
  }, [studyId]);

  if (!showWarning) return null;

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      The Survey Invite email template is not configured or enabled for this
      study. Invitation and reminder emails will not be sent until one is set in{" "}
      <Link
        component={RouterLink}
        to={`/studies/${studyId}/study-settings?type=email_config`}
        underline="hover"
      >
        Study Settings → Email
      </Link>
      .
    </Alert>
  );
};

export default SurveyInviteTemplateBanner;
